import Honeybadger from 'lib/honeybadger';
import axios from 'axios';

export const sendData = (name, label = '', status = 'ok', error = '') => {
  axios.post('https://attache.bukalapak.com/samples', {
    name,
    kind: 'c',
    value: 1,
    labels: {
      label,
      error,
      status,
    },
    additional: [],
  });
};

export const notifyErrors = (label, errorObject, params = {}) => {
  const options = {
    name: 'smaug',
    params,
    context: {
      label,
    },
  };

  if (Honeybadger && process.env.NODE_ENV !== 'development') {
    Honeybadger.notify(errorObject, options);
  } else {
    console.warn('Honeybadger.notify', { errorObject, options });
  }
};

export default {
  sendData,
  notifyErrors,
};
